import { FileReference } from './FileReference'

export type FeaturePropertyTypes = 'asset' | 'boolean' | 'color' | 'decimal' | 'image' | 'integer' | 'latlng' | 'string' | 'vector3' | 'customField'

export type FeaturePropertyOptions = {
    id?: number,
    featureID?: number,
    fileReferenceID?: number,
    fileReference?: FileReference,
    s3ObjectReferenceId?: number,
    s3ObjectReference?: S3ObjectRef
}

export interface S3ObjectRef {
    id: number
    organization_id: string
    bucket: string
    key: string
    type: 'file' | 'folder'
    filename?: string
    size?: number
    label?: string
}

export class FeatureProperty {
    public id: number
    public featureID: number
    public fileReferenceID: number
    public fileReference: FileReference
    public s3ObjectReferenceId: number
    public s3ObjectReference: S3ObjectRef
    public type: FeaturePropertyTypes
    public key: string
    public value: any

    constructor(type: FeaturePropertyTypes, key: string, value: string, options?: FeaturePropertyOptions) {
        this.id = options?.id ? +options.id : undefined
        this.featureID = options?.featureID ? +options.featureID : undefined
        this.fileReferenceID = options?.fileReferenceID ? +options.fileReferenceID : undefined
        this.fileReference = options?.fileReference
            ? new FileReference(options.fileReference.id, options.fileReference.modelID, options.fileReference.file, options.fileReference)
            : undefined
        this.s3ObjectReferenceId = options?.s3ObjectReferenceId ? +options.s3ObjectReferenceId : undefined
        this.s3ObjectReference = options?.s3ObjectReference
        this.type = type
        this.key = key

        if (value == 'true') {
            this.value = true
        } else if (value == 'false') {
            this.value = false
        } else {
            this.value = value ?? ''
        }
    }

    public equals(property: FeatureProperty) {
        if (property === undefined) return false

        if (this.id != property.id ||
            this.featureID != property.featureID ||
            this.fileReferenceID != property.fileReferenceID ||
            this.s3ObjectReferenceId != property.s3ObjectReferenceId ||
            this.type != property.type ||
            this.key != property.key ||
            this.value != property.value) return false

        if (this.fileReference != null && !this.fileReference.equals(property?.fileReference))
            return false

        return true
    }

    /** Returns true if this property references a stored file (EFS or S3), not a remote URL */
    get isStoredFile(): boolean {
        return this.fileReferenceID != null || this.s3ObjectReferenceId != null
    }

    /** Returns the display filename from either EFS or S3 storage */
    get displayFilename(): string {
        return this.fileReference?.filename ?? this.s3ObjectReference?.filename ?? 'Unknown file'
    }
}